var base_ws_server_path;
var base_opponent_name;
var basesessionkey;
export const summaryLink = $('html').data('user-summary-url');
export const msgsummaryLink = $('html').data('user-msgsummary-url');
export const $chatDropdown = $('.userlist');

$(document).ready(function () {
	
var websocket = null;
var monitor = null;


            function getOpponnentUsername() {
                return base_opponent_name;
            }

            // TODO: Use for adding new dialog
            function addNewUser(packet) {
                $('#user-list').html('');
                packet.value.forEach(function (userInfo) {
                    if (userInfo.email == getUsername()) return;
                    var tmpl = Handlebars.compile($('#user-list-item-template').html());
                    $('#user-list').append(tmpl(userInfo))
                });
            }

            function addNewMessage(packet) {
				console.log("In addNewMessage")
                var msg_class = "";
                if (packet['sender_name'] == $("#owner_username").val()) {
                    msg_class = "pull-left";
                } else {
                    msg_class = "pull-right";
                }
                var msgElem =
                    $('<div class="row msg-unread" data-id="' + packet.message_id + '">' +
                        '<p class="' + msg_class + '">' +
                        '<span class="email">' + packet['sender_name'] + ': </span>' +
                        packet['message'] +
                        ' <span class="timestamp">&ndash; <span data-livestamp="' + packet['created'] + '"> ' + packet['created'] + '</span></span> ' +
                        '</p> ' +
                        '</div>');
				console.log(packet['message']);
                $('#messages').append(msgElem);
				
				var messagesContainer = $('.messages');

				messagesContainer.append([
					'<li class="other">',
					packet['message'],
					'</li>'
				].join(''));
				
                var $target = $(".userlist").has("li");
		        if($target.find('[value="' + packet['sender_name'] + '"]').length > 0){
	            $target.find('[value="' + packet['sender_name'] + '"]').addClass("animated");
				console.log("pulsing",packet['sender_name']);
				}
				
                scrollToLastMessage()
            }

            function scrollToLastMessage() {
                var $msgs = $('#messages');
                $msgs.animate({"scrollTop": $msgs.prop('scrollHeight')})
            }

            function generateMessage(context) {
                var tmpl = Handlebars.compile($('#chat-message-template').html());
                return tmpl({msg: context})
            }
            function convertemail(email){
			    email = email.split('.').join('\\.');	
                email = email.split('@').join('\\@');
				return email;
			}
            function setUserOnlineOffline(email, online) {
				console.log("setUserOnlineOffline",email,online)
                //email=convertemail(email);			
               // var elem = $("#"+email);
			   var $target = $(".userlist").has("li");

                if (online) {
                    //elem.attr("class", "btn btn-success");
					$target.find('[value="' + email + '"]').css('background', 'green');
                    //console.log("going online", email);					
                } else {
                    $target.find('[value="' + email + '"]').css('background', 'red');
					//console.log("going offline", email);		
                }
            }

            function gone_online() {
                //$("#offline-status").hide();
                //$("#online-status").show();
				$(".title").css('color', 'green');
            }

            function gone_offline() {
                //$("#online-status").hide();
                //$("#offline-status").show();
				$(".title").css('color', 'white'); 
            }

            function flash_user_button(email) {
                var btn = $("#user-" + email);
                btn.fadeTo(700, 0.1, function () {
                    $(this).fadeTo(800, 1.0);
                });
            }
            
			
			
            function setupChatWebSocket() {
				
                var opponent_username = getOpponnentUsername();
				console.log("Server channel\n")
				console.log(base_ws_server_path + basesessionkey +'/'+ base_opponent_name)				
				console.log("Server channel end\n")				
                websocket = new WebSocket(base_ws_server_path + basesessionkey +'/'+  base_opponent_name);
                console.log("Server websocket created\n")	
                websocket.onopen = function (event) {
                    var opponent_username = getOpponnentUsername();

                    var onOnlineCheckPacket = JSON.stringify({
                        type: "check-online",
                        session_key: basesessionkey,
                        email: opponent_username
                        //{#                      Sending username because the user needs to know if his opponent is online #}
                    });
                    var onConnectPacket = JSON.stringify({
                        type: "online",
                        session_key: basesessionkey

                    });

                    console.log('connected, sending:', onConnectPacket);
                    websocket.send(onConnectPacket);
                    console.log('checking online opponents with:', onOnlineCheckPacket);
                    websocket.send(onOnlineCheckPacket);
                    //monitor = initScrollMonitor();
                };


                window.onbeforeunload = function () {

                    var onClosePacket = JSON.stringify({
                        type: "offline",
                        session_key: basesessionkey,
                        email: opponent_username,
                       // {# Sending username because to let opponnent know that the user went offline #}
                    });
                    console.log('unloading, sending:', onClosePacket);
                    websocket.send(onClosePacket);
                    websocket.close();
                };


                websocket.onmessage = function (event) {
                    var packet;

                    try {
                        packet = JSON.parse(event.data);
                        console.log(packet)
                    } catch (e) {
                        console.log(e);
                    }

                    switch (packet.type) {
                        case "new-dialog":
                            // TODO: add new dialog to dialog_list
                            break;
                        case "user-not-found":
                            // TODO: dispay some kind of an error that the user is not found
                            break;
                        case "gone-online":
                            if (packet.usernames.indexOf(opponent_username) != -1) {
                                gone_online();
                            } else {
                                gone_offline();
                            }
                            for (var i = 0; i < packet.usernames.length; ++i) {
                                setUserOnlineOffline(packet.usernames[i], true);
                            }
                            break;
                        case "gone-offline":
                            if (packet.email == opponent_username) {
                                gone_offline();
                            }
                            setUserOnlineOffline(packet.email, false);
                            break;
                        case "new-message":
                            var email = packet['sender_name'];
							var owneremail=$("#owner_username").val()
							console.log(email,opponent_username,owneremail)
                           if (email == opponent_username){
							   console.log("going to  addNewMessage")
                                addNewMessage(packet);
                                if (email == opponent_username) {
                                    //initReadMessageHandler(monitor, $("div[data-id='" + packet['message_id'] + "']"));
                                }
                            } else {
								console.log("add too user chat list")
                                /*if ($("#user-"+email).length == 0){
                                    var new_button = $(''+
                                        '<a href="/'+ email + '"' +
                                        'id="user-'+email+'" class="btn btn-danger">{% trans "Chat with" %} '+email+'</a>');
                                    $("#user-list-div").find("ul").append()
                                }*/
                                //flash_user_button(email);

                            }
                            break;
                        case "opponent-typing":
                            var typing_elem = $('#typing-text');
                            if (!typing_elem.is(":visible")) {
                                typing_elem.fadeIn(500);
                            } else {
                                typing_elem.stop(true);
                                typing_elem.fadeIn(0);
                            }
                            typing_elem.fadeOut(3000);
                            break;
                        case "opponent-read-message":
                            if (packet['email'] == opponent_username) {
                                $("div[data-id='" + packet['message_id'] + "']").removeClass('msg-unread').addClass('msg-read');
                            }
                            break;

                        default:
                            console.log('error: ', event)
                    }
                }
				
				
            }

			
	
var element = $('.floating-chat');
var myStorage = localStorage;

if (!myStorage.getItem('chatID')) {
    myStorage.setItem('chatID', createUUID());
}

setTimeout(function() {
    element.addClass('enter');
}, 1000);

element.click(openElement);

function openElement() {

  $.get(summaryLink, (data) => {
	//console.log(data);

   // $chatDropdown.html(data);
	//console.log("Raju RAJU");
	//console.log(data);  
var user_list = JSON.parse(data);
	//console.log("Raju RAJU1");
	//console.log(user_list);
	
	
//Reset the Whole userlist and rebuild 
  var container =document.getElementById("userlist")
  //container.innerHTML = "";

	
  $.each(user_list, function(index0, l) {

         $.each(l, function(index1, n) {

             /// iterate through the objects

             var userid = n.id;
             var username = n.email;
			 var is_staff=n.is_staff;
             console.log(userid,username,is_staff,$("#owner_username_is_staff").val())

             // do something with user_name and userid... 
			if(username != $("#owner_username").val()){
					 var $target = $(".userlist").has("li");
					
					if ($target.has('[value="' + username + '"]').length > 0){
						console.log("already there in the li", username)
						
					}
					else{
                           if($("#owner_username_is_staff").val() == 'True'){
							   console.log("adding new li for session owner staff ", username)							
								var li = document.createElement('li');
								li.className = 'self'; // Class name
								li.setAttribute('value', username);
								  var textnode = document.createTextNode(username);
								  li.appendChild(textnode);
								  var container =document.getElementById("userlist")
								   if (container !== null) {
										container.appendChild(li);
									} else console.log("userlist ID not found");
						   }
						   else if(is_staff){
							    console.log("adding new li for", username)							
								var li = document.createElement('li');
								li.className = 'self'; // Class name
								li.setAttribute('value', username);
								  var textnode = document.createTextNode(username);
								  li.appendChild(textnode);
								  var container =document.getElementById("userlist")
								   if (container !== null) {
										container.appendChild(li);
									} else console.log("userlist ID not found");
							   
							   
						   }
					}
					
					
				  
			}
         });
    });



    var messages = element.find('.messages');
    var userlist = element.find('.userlist');	
    var textInput = element.find('.text-box');
    element.find('>i').hide();
    element.addClass('expand');
    element.find('.chat').addClass('enter');
    var strLength = textInput.val().length * 2;
    textInput.keydown(onMetaAndEnter).prop("disabled", false).focus();
    element.off('click', openElement);
    element.find('.header button').click(closeElement);
    element.find('#sendMessage').click(sendNewMessage);
	element.find('.self').click(Userlist);
    messages.scrollTop(messages.prop("scrollHeight"));
	userlist.scrollTop(messages.prop("scrollHeight"));
	$(".title").text("Chat List");
	$('.userlist').show();
	$('.messages').hide();
	$('.footeer').hide();  
	$('.back').hide();	
  });
	
	//console.log("Raju RAJU2");	
}

function closeElement() {
    element.find('.chat').removeClass('enter').hide();
    element.find('>i').show();
    element.removeClass('expand');
    element.find('.header button').off('click', closeElement);
    element.find('#sendMessage').off('click', sendNewMessage);
    element.find('.text-box').off('keydown', onMetaAndEnter).prop("disabled", true).blur();
    setTimeout(function() {
        element.find('.chat').removeClass('enter').show()
        element.click(openElement);
    }, 500);
}

function Userlist(){

	var value = $(this).attr('value');

					
	var $target = $(".userlist").has("li");
	if($target.find('[value="' + value+ '"]').length > 0){
	$target.find('[value="' + value + '"]').removeClass("animated");
	console.log("pulsing",value);
	}
				
	//alert("good")
	//alert(value);	
	base_opponent_name=value;
    $('.userlist').hide();
	$('.messages').show();
	$('.footeer').show();	
	$(".title").text(value);
	$('.back').show();
    element.find('.back').click(function(event){
	//https://javascript.info/bubbling-and-capturing
	event.stopImmediatePropagation()
	console.log("stopImmediatePropagation")
	openElement();
	});
	


      $.get('/account/specificuser', {'sendermail': value, 'ownermail':$("#owner_username").val()}, function(servermessages) {
        //$('#output').html(data); // append to inner html
        //console.log(messages);
var jsonServMessages = JSON.parse(servermessages);
	//console.log("Raju RAJU1");
	//console.log(jsonServMessages);
	
	
//Reset the Whole messages and rebuild 
  var messagesContainer = $('.messages');
  messagesContainer.html('');
	
  $.each(jsonServMessages, function(index0, l) {

         $.each(l, function(index1, n) {
			 //console.log(n.email, n.message);
			 if (n.email == $("#owner_username").val()){
				 
				messagesContainer.append([
					'<li class="self">',
					n.message,
					'</li>'
				].join(''));
	
			 }
			 else{
				 
				messagesContainer.append([
					'<li class="other">',
					n.message,
					'</li>'
				].join(''));
				
			 }

         });
  });		 
		
		
		
});


	console.log("Chat flex base_opponent_name1", base_ws_server_path,basesessionkey,base_opponent_name,);
	setupChatWebSocket();

		
}
//this also works as Userlist
//$('.self').on('click',function(){
//	var value = $(this).attr('value');
//	alert(value);
//});

function createUUID() {
    // http://www.ietf.org/rfc/rfc4122.txt
    var s = [];
    var hexDigits = "0123456789abcdef";
    for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    var uuid = s.join("");
    return uuid;
}



function sendNewMessage() {
    var userInput = $('.text-box');
    var newMessage = userInput.html().replace(/\<div\>|\<br.*?\>/ig, '\n').replace(/\<\/div\>/g, '').trim().replace(/\n/g, '<br>');

    if (!newMessage) return;

    var messagesContainer = $('.messages');

    messagesContainer.append([
        '<li class="self">',
        newMessage,
        '</li>'
    ].join(''));

    // clean out old message
    userInput.html('');
    // focus on input
    userInput.focus();

    messagesContainer.finish().animate({
        scrollTop: messagesContainer.prop("scrollHeight")
    }, 250);
	
                var opponent_username = getOpponnentUsername();
                var newMessagePacket = JSON.stringify({
                    type: 'new-message',
                    session_key: basesessionkey,
                    email: opponent_username,
                    message: newMessage
                });
                websocket.send(newMessagePacket)
				
}

function onMetaAndEnter(event) {
    if ((event.metaKey || event.ctrlKey) && event.keyCode == 13) {
        sendNewMessage();
    }
}

var $chatServerName = $('#chat-server-name');
                var value = $chatServerName.val();
                if (!value) return;
				base_ws_server_path = value;
				console.log("chatflex server=",base_ws_server_path)

var $chatSessionKey = $('#chat-session-key');
                var value = $chatSessionKey.val();
                if (!value) return;
				basesessionkey = value;
				console.log("chatflex session=",basesessionkey)	
				
var $chatOpponentname = $('#chat-opponent-username');
                var value = $chatOpponentname.val();
                if (!value) return;
				base_opponent_name = value;
				console.log("chatflex opponent=",base_opponent_name)	
				

				



});


